import { render } from "./TasksEstimatedOverdueListView.vue?vue&type=template&id=106e8dd9"
import script from "./TasksEstimatedOverdueListView.vue?vue&type=script&lang=js"
export * from "./TasksEstimatedOverdueListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__